import { Pill, type PillProps } from "@/components/podkit/status/Pill";
import type React from "react";
import { type FC } from "react";
import type { CentralIconBaseProps } from "central-icons/CentralIconBase";

export const AutomationStepKindPill: FC<
    Omit<PillProps, "LeadingIcon"> & { LeadingIcon: React.FC<CentralIconBaseProps> }
> = ({ LeadingIcon, ...props }) => {
    return (
        <Pill
            size="md"
            className="select-none px-2 py-1 font-medium"
            LeadingIcon={() => <LeadingIcon size={16} />}
            {...props}
        />
    );
};
